import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import FloatingButtons from "./FloatingButtons";
import { Toaster } from "./ui/sonner";

export const Layout = ({ children }) => {
  return (
    <div className="App min-h-screen flex flex-col bg-[hsl(var(--background))]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingButtons />
      <Toaster richColors position="top-center" />
    </div>
  );
};

export default Layout;
